module.exports = __webpack_public_path__ + "media/images/new-ui-images/tick-838107ce36e8155a8f4c06e9705974ef.svg";